export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;

/* eslint-disable import/first */
import geojson from 'geojson';
import { OperatorName } from 'constants/operators';

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    AggregatedTripsHexData: { input: any; output: any };
    AreaOriginDestinationReportAreaData: { input: any; output: any };
    Bounds: {
        input: [number, number, number, number];
        output: [number, number, number, number];
    };
    Date: { input: string; output: string };
    DateRange: { input: [string, string]; output: [string, string] };
    DateTime: { input: string; output: string };
    Geometry: { input: geojson.Geometry; output: geojson.Geometry };
    HourlyDeploymentCount: {
        input: [number, number];
        output: [number, number];
    };
    OperatorName: { input: OperatorName; output: OperatorName };
    RawData: { input: any; output: any };
    Time: { input: any; output: any };
};

export enum AggregatedReportPeriod {
    monthly = 'monthly',
    weekly = 'weekly'
}

export enum AggregationTripDataType {
    trip_ends = 'trip_ends',
    trip_starts = 'trip_starts'
}

/** An enumeration. */
export enum AnalyzeDataAggregateUnit {
    co2_tons = 'co2_tons',
    hours = 'hours',
    kilometers = 'kilometers',
    miles = 'miles',
    minutes = 'minutes',
    seconds = 'seconds',
    trips = 'trips',
    trips_per_day = 'trips_per_day',
    trips_per_day_by_hour = 'trips_per_day_by_hour',
    trips_per_hour = 'trips_per_hour',
    trips_per_vehicle = 'trips_per_vehicle',
    vehicles = 'vehicles'
}

/** An enumeration. */
export enum AnalyzeDataXUnit {
    date = 'date',
    day_and_hour = 'day_and_hour',
    hour = 'hour',
    kilometers = 'kilometers',
    miles = 'miles',
    minutes = 'minutes',
    weekday = 'weekday'
}

/** An enumeration. */
export enum AnalyzeDataYUnit {
    co2_tons = 'co2_tons',
    hours = 'hours',
    kilometers = 'kilometers',
    miles = 'miles',
    minutes = 'minutes',
    seconds = 'seconds',
    trips = 'trips',
    trips_per_vehicle = 'trips_per_vehicle',
    vehicles = 'vehicles'
}

export type CreateAreaOfInterestInput = {
    geometry: Scalars['Geometry']['input'];
    mapviewId: Scalars['ID']['input'];
    name: Scalars['String']['input'];
    operators?: InputMaybe<Array<Scalars['ID']['input']>>;
    priority?: InputMaybe<Scalars['Int']['input']>;
    sharedWithOperators?: InputMaybe<Scalars['Boolean']['input']>;
    tableViewOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreatePolicyInput = {
    description: Scalars['String']['input'];
    endDate?: InputMaybe<Scalars['Date']['input']>;
    mapviewId: Scalars['ID']['input'];
    minDeploymentUnits?: InputMaybe<MinDeploymentUnits>;
    name: Scalars['String']['input'];
    operatorIds: Array<Scalars['ID']['input']>;
    policyType: PolicyType;
    rules: Array<InputMaybe<CreatePolicyRuleInput>>;
    startDate: Scalars['Date']['input'];
};

export type CreatePolicyRuleInput = {
    areaIds: Array<InputMaybe<Scalars['ID']['input']>>;
    days?: InputMaybe<Array<Day>>;
    endTime?: InputMaybe<Scalars['Time']['input']>;
    farePrograms?: InputMaybe<Array<FareProgram>>;
    maximum?: InputMaybe<Scalars['Int']['input']>;
    minimum?: InputMaybe<Scalars['Int']['input']>;
    name: Scalars['String']['input'];
    rateAmount?: InputMaybe<Scalars['Int']['input']>;
    ruleType: RuleType;
    startTime?: InputMaybe<Scalars['Time']['input']>;
    summaryStatistic?: InputMaybe<Scalars['String']['input']>;
    vehicleClasses?: InputMaybe<Array<VehicleClass>>;
};

export type CreateTripFilterInput = {
    maxDistance?: InputMaybe<Scalars['Int']['input']>;
    maxDuration?: InputMaybe<Scalars['Int']['input']>;
    minDistance?: InputMaybe<Scalars['Int']['input']>;
    minDuration?: InputMaybe<Scalars['Int']['input']>;
    vehicleClass: VehicleClass;
};

export enum CustomerStageType {
    Demo = 'Demo',
    StageOne = 'StageOne',
    StageThree = 'StageThree',
    StageTwo = 'StageTwo',
    Trial = 'Trial'
}

export enum Day {
    friday = 'friday',
    monday = 'monday',
    saturday = 'saturday',
    sunday = 'sunday',
    thursday = 'thursday',
    tuesday = 'tuesday',
    wednesday = 'wednesday'
}

export type DeletePolicyInput = {
    mapviewId: Scalars['ID']['input'];
    policyId: Scalars['String']['input'];
};

export type EditAreaInput = {
    agencyOnly?: InputMaybe<Scalars['Boolean']['input']>;
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    areaId: Scalars['ID']['input'];
    name?: InputMaybe<Scalars['String']['input']>;
    priority?: InputMaybe<Scalars['Int']['input']>;
    tableViewOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EditPolicyInput = {
    description: Scalars['String']['input'];
    endDate?: InputMaybe<Scalars['Date']['input']>;
    isPublic: Scalars['Boolean']['input'];
    mapviewId: Scalars['ID']['input'];
    name: Scalars['String']['input'];
    operatorIds: Array<Scalars['ID']['input']>;
    policyId: Scalars['ID']['input'];
    startDate: Scalars['Date']['input'];
};

export type EditStreetSegmentInput = {
    geometryId: Scalars['ID']['input'];
    mapviewId: Scalars['ID']['input'];
    name: Scalars['String']['input'];
};

export enum EventLocationsDataType {
    deployments = 'deployments',
    trip_ends = 'trip_ends',
    trip_starts = 'trip_starts'
}

/** Fare programs for trip metrics. */
export enum FareProgram {
    access = 'access',
    member = 'member',
    standard = 'standard'
}

export enum FeatureFlaggedFeature {
    area_origin_destination_counts = 'area_origin_destination_counts',
    area_ridesheds = 'area_ridesheds',
    fare_programs = 'fare_programs',
    prohibit_routes_computation = 'prohibit_routes_computation',
    regional_dashboard = 'regional_dashboard',
    store_trip_street_segments = 'store_trip_street_segments'
}

/**
 * The possible states of incidents that may be requested
 *
 * Represents a binary concept of incidents: either they are closed
 * (resolved) or open (unresolved)
 */
export enum IncidentState {
    resolved = 'resolved',
    unresolved = 'unresolved'
}

/** An enumeration. */
export enum MeasurementUnitSystemType {
    IMPERIAL = 'IMPERIAL',
    METRIC = 'METRIC'
}

export enum MinDeploymentUnits {
    num_devices = 'num_devices',
    percentage = 'percentage'
}

/** The possible OSM road class values for Street Segment road classifications. */
export enum OsmRoadClass {
    motorway = 'motorway',
    other = 'other',
    primary = 'primary',
    residential = 'residential',
    secondary = 'secondary',
    service = 'service',
    tertiary = 'tertiary',
    trunk = 'trunk',
    unclassified = 'unclassified'
}

export enum OperatorStageType {
    Certified = 'Certified',
    DataSharing = 'DataSharing',
    Preferred = 'Preferred'
}

export enum OrganizationType {
    Agency = 'Agency',
    Operator = 'Operator'
}

export enum PolicyType {
    max_idle_time = 'max_idle_time',
    mean_active = 'mean_active',
    minimum_deployment = 'minimum_deployment',
    minimum_deployment_percentage = 'minimum_deployment_percentage',
    no_parking_zone = 'no_parking_zone',
    no_ride_zone = 'no_ride_zone',
    provider_deployment_cap = 'provider_deployment_cap',
    provider_deployment_minimum = 'provider_deployment_minimum',
    right_of_way = 'right_of_way',
    speed_limit = 'speed_limit',
    trip_end = 'trip_end',
    trip_start = 'trip_start',
    trip_start_and_stop = 'trip_start_and_stop',
    trip_start_or_stop = 'trip_start_or_stop',
    trip_start_xor_stop = 'trip_start_xor_stop',
    vehicle_cap = 'vehicle_cap',
    vehicle_cap_percentage = 'vehicle_cap_percentage'
}

export type ReplaceAreaOfInterestInput = {
    geometry?: InputMaybe<Scalars['Geometry']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    operators?: InputMaybe<Array<Scalars['ID']['input']>>;
    previousVersionId: Scalars['ID']['input'];
    priority?: InputMaybe<Scalars['Int']['input']>;
    sharedWithOperators?: InputMaybe<Scalars['Boolean']['input']>;
    tableViewOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum RuleType {
    count = 'count',
    rate = 'rate',
    speed = 'speed',
    time = 'time',
    user = 'user'
}

export enum UserRoleType {
    Administrator = 'Administrator',
    User = 'User'
}

/**
 * What kind of vehicle it is. Distinct from the much more granular concept
 * of an mds vehicle_type.
 */
export enum VehicleClass {
    bike = 'bike',
    bus = 'bus',
    car = 'car',
    cargo_bike = 'cargo_bike',
    cargo_ebike = 'cargo_ebike',
    delivery_robot = 'delivery_robot',
    ebike = 'ebike',
    moped = 'moped',
    motorcycle = 'motorcycle',
    other = 'other',
    pedestrian = 'pedestrian',
    scooter = 'scooter',
    seated_scooter = 'seated_scooter',
    truck = 'truck'
}
